import Dashboard from "layouts/dashboard";
import Transactions from "layouts/tables";
import Billing from "layouts/billing";
import Analytics from "layouts/analytics";
import Insights from "layouts/insights";
import SignIn from "layouts/authentication/sign-in";

import { IoHome, IoStatsChart, IoSparkles } from "react-icons/io5";
import { BsCreditCardFill } from "react-icons/bs";
import { IoIosDocument } from "react-icons/io";
import { FaChartPie } from "react-icons/fa";

const routes = [
  {
    type: "collapse",
    name: "Overview",
    key: "dashboard",
    route: "/dashboard",
    icon: <IoHome size="15px" color="inherit" />,
    component: Dashboard,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Transactions",
    key: "transactions",
    route: "/transactions",
    icon: <IoStatsChart size="15px" color="inherit" />,
    component: Transactions,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Income",
    key: "income",
    route: "/income",
    icon: <BsCreditCardFill size="15px" color="inherit" />,
    component: Billing,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Analytics",
    key: "analytics",
    route: "/analytics",
    icon: <FaChartPie size="15px" color="inherit" />,
    component: Analytics,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "AI Insights",
    key: "insights",
    route: "/insights",
    icon: <IoSparkles size="15px" color="inherit" />,
    component: Insights,
    noCollapse: true,
  },
  {
    type: "route",
    name: "Sign In",
    key: "sign-in",
    route: "/authentication/sign-in",
    component: SignIn,
  },
];

export default routes;
